

<div class="app-wrapper app-home">
    <div *ngIf="app" class="apps-container">
        <card class="app-card">
            <div class="card-header-content">
                <h1>
                    <fa-icon [icon]="app.icon | iconNameToDefinition"></fa-icon>
                    {{app.name}}
                </h1>
            </div>
            <div class="card-body-content">
                <div class="app-links" *ngIf="graph?.length; else noConfig">

                    <a *ngFor="let link of graph"
                       [class]="link.code"
                       [routerLink]="link.url">
                        <span>{{link.name}}</span>
                        <label class="resum">
                            {{link.content.number}}
                            <fa-icon [icon]="faTable"></fa-icon>
                            {{link.content.line}}
                            <fa-icon [icon]="faLine"></fa-icon>
                            {{link.content.bar}}
                            <fa-icon [icon]="faBar"></fa-icon>
                            {{link.content.pie}}
                            <fa-icon [icon]="faPie"></fa-icon>
                        </label>
                    </a>
                </div>
                <ng-template #noConfig>
                    <notification type="error">
                        {{noConfigErrorMsg}}
                    </notification>
                </ng-template>
            </div>
        </card>
    </div>
</div>
